"use client";
import React, { useState, useEffect } from 'react';
import { ShoppingCart, ExternalLink } from 'lucide-react';

const ShoppingWidget = ({ settings = {} }) => {
  const shoppingProducts = settings?.shoppingProducts || [];
  const [displayProducts, setDisplayProducts] = useState([]);

  useEffect(() => {
    if (shoppingProducts && shoppingProducts.length > 0) {
      const shuffled = [...shoppingProducts].sort(() => Math.random() - 0.5);
      setDisplayProducts(shuffled.slice(0, 5));
    }
  }, [shoppingProducts]);

  if (!displayProducts || displayProducts.length === 0) return null;

  return (
    <div className="bg-brand-surface border border-brand-border shadow-sm mt-8 p-5">
      <div className="flex items-center gap-2 mb-4 border-b border-brand-border pb-3">
        <ShoppingCart className="w-5 h-5 text-brand-primary" />
        <h3 className="text-xl font-black italic tracking-tighter uppercase text-brand-text">
          Shopping <span className="text-[10px] text-brand-muted ml-1 font-bold">(POWERED BY AMAZON)</span>
        </h3>
      </div>
      
      <div className="flex flex-col gap-4">
        {displayProducts.map((product) => (
          <a 
            key={product.id}
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-4 group items-center border-b border-brand-border pb-4 last:border-0 last:pb-0"
          >
            {/* Image Container using object-contain */}
            <div className="w-20 h-20 bg-brand-surface-alt flex-shrink-0 border border-brand-border p-1 flex items-center justify-center rounded">
              <img 
                src={product.image} 
                alt={product.title} 
                className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-300" 
              />
            </div>
            
            <div className="flex-1 flex flex-col justify-between h-full py-1">
              <h4 className="text-sm font-bold text-brand-text leading-tight line-clamp-2 group-hover:text-brand transition-colors mb-1">
                {product.title}
              </h4>
              <div className="text-brand-primary font-black text-sm flex items-center justify-between mb-2">
                <span>{product.price}</span>
              </div>
              <div>
                <span className="inline-block bg-brand-primary text-brand-text-inverse text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded group-hover:bg-[var(--brand-surface-hover)] transition-colors">
                  Shop Now
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-brand-border">
        <a href="/shopping" className="block w-full text-center bg-brand-secondary py-3 text-[#cac3ad] hover:bg-brand hover:text-black text-sm font-black uppercase tracking-widest transition-colors rounded">
          See More Products
        </a>
      </div>
    </div>
  );
};

export default ShoppingWidget;
